import type { SvgIconPath } from 'src/tpbp-configuration/models/svg-icon.types'
import type {
  Toast,
  ToastKinds,
} from 'src/tpbp-core/models/toaster/toaster.types'
import { ToastKind } from 'src/tpbp-core/models/toaster/toaster.types'
import type {
  ToastConfig,
  ToastView,
} from 'src/tpbp-ds/components/toaster-container/toast-view.types'
import type { TailwindColor } from 'src/utils/getColor'

function computeToastConfig(
  tailwindColor: TailwindColor,
  iconPath: SvgIconPath,
): ToastConfig {
  return {
    textColor: `text-${tailwindColor}`,
    borderColor: `border-${tailwindColor}`,
    iconPath,
  }
}

export const TOAST_KIND_TO_COLOR_SET_MAPPER = {
  [ToastKind.ERROR]: computeToastConfig(
    'sunset-500',
    'monochrome/circle-error.svg',
  ),
  [ToastKind.WARN]: computeToastConfig(
    'ochre-500',
    'monochrome/triangle-warn.svg',
  ),
  [ToastKind.SUCCESS]: computeToastConfig(
    'malachite-500',
    'monochrome/circle-success.svg',
  ),
  [ToastKind.INFO]: computeToastConfig(
    'cerulean-500',
    'monochrome/circle-info.svg',
  ),
} as const satisfies Record<ToastKinds, ToastConfig>

export function mapToastsToToastViews(toasts: Toast[]): ToastView[] {
  return toasts.map((toast) => ({
    kind: toast.kind,
    title: toast.title,
    description: toast.description ?? '',
    ...TOAST_KIND_TO_COLOR_SET_MAPPER[toast.kind],
  }))
}
